import { AxiosRequest } from "_services/api";
import { toastErro } from "components/Toast";
import { useCallback, useEffect, useMemo, useState } from "react";
import { TipoSolicitacaoPlaca } from "../constants/tipoSolicitacaoPlaca";
import { mensagemDeErro } from "../utils/mensagemDeErro";

export function useTotalPendentes(tipo: TipoSolicitacaoPlaca) {
  const msAw = useMemo(
    () => AxiosRequest.makeApi(process.env.REACT_APP_MS_AW),
    []
  );
  const [total, setTotal] = useState(0);

  const recarregarTotal = useCallback(async () => {
    try {
      const { data } = await msAw.get(
        `/solicitacao-placa/total?${new URLSearchParams({ tipo })}`
      );
      setTotal(Number(data?.total ?? 0));
    } catch (erro) {
      toastErro(mensagemDeErro(erro, "Erro ao buscar o total de solicitações"));
    }
  }, [msAw, tipo]);

  useEffect(() => {
    recarregarTotal();
  }, [recarregarTotal]);

  return { total, recarregarTotal };
}
